<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actuals - Mileage Report Daily</span><br/>
      <span style="font-style: italic; font-size: 18px">this report highlights differences between planned miles, calculated actual booking miles & Telematics daily trip miles on a given date.  select a row for more details</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Get Results</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(true)" :disabled="loading">Rerun Report</b-button>
    </div>

    <div v-if="!loading">
      <div style="font-size: 22px; font-weight: bold;">
        <div v-if="summary.total_cnt" class="col" style="float:left; max-width:200px; border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div v-if="items_full.length > 0" style="float:right;margin-bottom: 20px">
          <span class="d-flex align-items-center justify-content-center">
            Filter&nbsp;<b-form-input style="width: 310px" v-model="vehicle_filter" placeholder="charterID, movementID, vehicle, driver"/>
            &nbsp;&nbsp;&nbsp;Mileage Diff&nbsp;&nbsp;<b-form-select v-model="duration_threshold" :options="duration_threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
          </span>
        </div>
      </div>
    </div>

    <div v-if="!loading">
      <table width="100%" border='1' cellpadding='0' cellspacing="0">
        <tr>
          <th colspan="6" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
          <th colspan="5" style="background-color: #C6C6C6">Calulated Booking Actuals</th>
          <th colspan="3" style="background-color: #E5E5E5">Telematics Daily Totals</th>
          <th colspan="2" style="background-color: #A5A5A5">Mileage Diffs</th>
        </tr>
        <tr>
          <th width="80px" @click="sort_strings('vehicle')">Vehicle</th>
          <th width="90px" @click="sort_numbers('charterIDs')">BookingID</th>
          <th width="90px" @click="sort_numbers('movementIDs')">MovementID</th>
          <th width="80px" @click="sort_strings('drivers')">Driver</th>
          <th width="80px" @click="sort_strings('is_multiday')">Multiday</th>
          <th width="100px" @click="sort_numbers('plannedTotalDistance')">Planned Mileage</th>
          <th width="100px" @click="sort_dates('actualHOSStartDateTime')">Driver Start</th>
          <th width="100px" @click="sort_dates('actualHOSFinishDateTime')">Driver Finish</th>
          <th width="100px" @click="sort_numbers('actualStartOdometer')">Start Odometer</th>
          <th width="100px" @click="sort_numbers('actualEndOdometer')">End Odometer</th>
          <th width="100px" @click="sort_numbers('actualTotalDistance')">Actuals Mileage</th>
          <th width="100px" @click="sort_numbers('samsaraStartOdometer')">Start Odometer</th>
          <th width="100px" @click="sort_numbers('samsaraEndOdometer')">End Odometer</th>
          <th width="100px" @click="sort_numbers('samsaraTotalDistance')">Trip Mileage</th>
          <th width="100px" @click="sort_numbers('actualMinusPlannedMiles')">Actual - Planned</th>
          <th width="100px" @click="sort_numbers('actualMinusSamsaraMiles')">Actual - Telematics</th>
        </tr>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{ item.vehicle | trim(12)}}</td>
            <td>
              <span v-if="item.charterIDs && item.charterIDs.includes(',')">+{{item.charterIDs.split(',')[0]}}</span>
              <span v-else>{{item.charterIDs}}</span>
            </td>
            <td>
              <span v-if="item.movementIDs && item.charterIDs.includes(',')">+{{item.movementIDs.split(',')[0]}}</span>
              <span v-else>{{item.movementIDs}}</span>
            </td>
            <td>{{ item.drivers | trim(20)}}</td>
            <td>{{ item.is_multiday}}</td>
            <td>{{item.plannedTotalDistance}}</td>
            <td>{{item.actualHOSStartDateTime | formatDateTimeSmall}}</td>
            <td>{{item.actualHOSFinishDateTime | formatDateTimeSmall}}</td>
            <td>{{item.actualStartOdometer}}</td>
            <td>{{item.actualEndOdometer}}</td>
            <td>{{item.actualTotalDistance}}</td>
            <td>{{item.samsaraStartOdometer}}</td>
            <td>{{item.samsaraEndOdometer}}</td>
            <td>{{item.samsaraTotalDistance}}</td>
            <td>{{item.actualMinusPlannedMiles}}</td>
            <td>{{item.actualMinusSamsaraMiles}}</td>
          </tr>
          <tr style="padding-bottom:10px; background-color: lightgoldenrodyellow !important" v-if="item.isMvmtsVisible" v-for="movement in item.movements">
            <td colspan="1">&nbsp;</td>
            <td>{{ movement.charterID }}</td>
            <td>{{ movement.movementID }}</td>
            <td>{{ movement.driver }} <span v-if="movement.driver_hos_link"><a target="_blank" :href="movement.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a></span></td>
            <td>{{ movement.is_multiday}}</td>
            <td>{{ movement.plannedDistance}}</td>
            <td>{{ movement.actualHOSStartDateTime | formatDateTimeSmall }}</td>
            <td>{{ movement.actualHOSFinishDateTime | formatDateTimeSmall }}</td>
            <td>{{ movement.actualStartOdometer }}</td>
            <td>{{ movement.actualEndOdometer }}</td>
            <td>{{ movement.actualTotalDistance }}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>{{item.actualMinusPlannedMiles}}</td>
            <td>&nbsp;</td>
          </tr>
        </template>
      </table>
    </div>
    <div v-else-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import {get_actuals_mileage_report} from "../networking/apis";

export default {
  name: 'actuals_mileage_cm',

  components: {
  },

  data() {
    return {
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      vehicle_filter: null,
      selected_vehicle_type: null,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      vehicle_type_options: [],
      duration_threshold: null,
      duration_threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10m' },
        { value: '15', text: '> 15m' },
        { value: '30', text: '> 30m' },
        { value: '45', text: '> 45m' },
        { value: '60', text: '> 1h' },
        { value: '120', text: '> 2h' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {

    },
    async load_data(reprocess) {
      this.loading = true
      try {
        this.selected_vehicle_type =''
        this.sort_col = 'vehicle'

        const { value: { data = [] }} = await get_actuals_mileage_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),reprocess)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.vehicle_type_options = data.summary.vehicle_types
      } catch(e) {
        this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_vehicle_type != '')
        this.items = this.items.filter(item => item.vehicle_type == this.selected_vehicle_type)
      if (this.vehicle_filter) {
        this.items = this.items.filter(item => (this.contains(item.movementIDs,this.vehicle_filter) || (this.contains(item.charterIDs,this.vehicle_filter) ||
            this.contains(item.drivers,this.vehicle_filter) || this.contains(item.vehicle,this.vehicle_filter))))
      }
      if (this.duration_threshold)
        this.items = this.items.filter(item => (Math.abs(item.actualMinusSamsaraMiles) > this.duration_threshold) || (Math.abs(item.actualMinusPlannedMiles) > this.duration_threshold))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_vehicle_type(val) {
      this.filter_items()
    },
    duration_threshold() {
      this.filter_items()
    },
    vehicle_filter() {
      this.filter_items()
    }
  }
}
</script>
<style scoped>

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
a {color: darkred}

th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

</style>


